import { Link, useLocation } from "react-router-dom";
import { decodeJWT } from "../Components/jwtUtils";
import { useEffect, useState } from "react";
import Api from "../Auth/Api";
import { Modal } from "react-bootstrap";

function Sidebar() {
    const location = useLocation();
    const token = JSON.parse(localStorage.getItem("user_token"));
    const claims = decodeJWT(token) || {};
    const nivel = claims.nivel;
    const ehSuperAdmin = claims.super_admin === true || nivel === 'Super Admin';
    const empresaIdAtual = claims.empresa_id ?? null;
    const superAdminSemEmpresa = ehSuperAdmin && !empresaIdAtual;

    const [mensagensNaoLidas, setMensagensNaoLidas] = useState([]);
    const [showModalRelatorios, setShowModalRelatorios] = useState(false);

    useEffect(() => {
        if (superAdminSemEmpresa) return;
        async function fetchData() {
            try {
                const response = await Api.get(`api/mensagens-nao-lidas`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setMensagensNaoLidas(response.data);
            } catch (error) {
                console.error(error);
            }
        }
        fetchData();
    }, [token, superAdminSemEmpresa]);

    const isActive = (path) => location.pathname.includes(path);

    // Super Admin sem empresa: Dashboard (home), Empresas e botão de Perfil
    if (superAdminSemEmpresa) {
        const foto = localStorage.getItem("foto");
        const nomeCompleto = localStorage.getItem("nome_completo") || '';
        const primeiroNome = nomeCompleto.split(' ')[0] || 'Perfil';
        const dashboardAtivo =
            location.pathname === '/' ||
            isActive('/dashboard') ||
            isActive('/empresa/');

        return (
            <div className="sidebar-content">
                <div className="d-flex flex-md-column align-items-center sidenav sidenav-superadmin">
                    <div className="d-flex flex-md-column justify-content-around w-100 sidenav-content">
                        <Link to="/" className="sidebar-link" title="Dashboard">
                            <div className={`menu-item-container ${dashboardAtivo ? 'menu-item-active' : ''}`}>
                                <div className="icon-container">
                                    <i className="menu-item bi bi-speedometer2"></i>
                                </div>
                                <span className="menu-label">Dashboard</span>
                            </div>
                        </Link>
                        <Link to="/listar-empresas" className="sidebar-link" title="Empresas">
                            <div className={`menu-item-container ${isActive('/listar-empresas') ? 'menu-item-active' : ''}`}>
                                <div className="icon-container">
                                    <i className="menu-item bi bi-buildings"></i>
                                </div>
                                <span className="menu-label">Empresas</span>
                            </div>
                        </Link>
                        <Link to="/configuracoes-globais" className="sidebar-link" title="Configurações Globais">
                            <div className={`menu-item-container ${isActive('/configuracoes-globais') ? 'menu-item-active' : ''}`}>
                                <div className="icon-container">
                                    <i className="menu-item bi bi-globe2"></i>
                                </div>
                                <span className="menu-label">Ajustes</span>
                            </div>
                        </Link>
                        <Link to="/super-admins" className="sidebar-link" title="Super Admins">
                            <div className={`menu-item-container ${isActive('/super-admins') ? 'menu-item-active' : ''}`}>
                                <div className="icon-container">
                                    <i className="menu-item bi bi-shield-lock"></i>
                                </div>
                                <span className="menu-label">Super Admins</span>
                            </div>
                        </Link>
                    </div>

                    {/* Perfil ao final do menu */}
                    <Link to="/configuracoes" className="sidebar-link mt-md-auto sidebar-profile-link" title="Perfil">
                        <div className={`menu-item-container ${isActive('/configuracoes') ? 'menu-item-active' : ''}`}>
                            <div className="icon-container">
                                {foto && foto !== 'null'
                                    ? <img alt="perfil" src={`${process.env.REACT_APP_API_URL}/fotos/${foto}`} className="rounded-circle object-fit-cover border border-light border-2" width={30} height={30} />
                                    : <i className="menu-item bi bi-person-circle"></i>}
                            </div>
                            <span className="menu-label">{primeiroNome}</span>
                        </div>
                    </Link>
                </div>
            </div>
        );
    }

    const menuItems = [
        {
            path: nivel === 'Aluno' ? '/aluno/dashboard' : '/dashboard',
            icon: 'bi-house-door-fill',
            label: 'Home',
            showFor: ['Aluno', 'Administrador', 'Gestor', 'RH'],
            isActive: (path) => isActive('/dashboard') || isActive('/aluno/dashboard')
        },
        {
            path: '/meus-cursos',
            icon: 'bi-book-fill',
            label: 'Cursos',
            showFor: ['Aluno', 'Administrador', 'Gestor', 'RH'],
            isActive: (path) => isActive('/meus-cursos') || isActive('/modulos/') || isActive('/aulas/') || isActive('/aula/') || isActive('/listar-alunos/')
        },
        {
            path: '/chat',
            icon: 'bi-chat-left-fill',
            label: 'Mensagens',
            showFor: ['Aluno', 'Administrador', 'Gestor', 'RH'],
            isActive: (path) => isActive('/chat'),
            badge: mensagensNaoLidas.mensagens_nao_lidas
        },
        {
            path: nivel === 'Aluno' ? '/aluno/certificado' : '/certificados',
            icon: 'bi-patch-check-fill',
            label: 'Certificado',
            showFor: ['Aluno', 'Administrador', 'Gestor', 'RH'],
            isActive: (path) => isActive('/certificados') || isActive('/aluno/certificado')
        },
        {
            path: '/biblioteca',
            icon: 'bi-hdd-fill',
            label: 'Biblioteca',
            showFor: ['Aluno', 'Administrador', 'Gestor', 'RH'],
            isActive: (path) => isActive('/biblioteca')
        },
        {
            path: '/agendamentos-treinamentos',
            icon: 'bi-calendar-check-fill',
            label: 'Agenda',
            showFor: ['Administrador', 'Gestor', 'RH'],
            isActive: (path) => isActive('/agendamentos-treinamentos')
        },
        {
            path: '#',
            icon: 'bi-clipboard2-data-fill',
            label: 'Relatórios',
            showFor: ['Administrador', 'Gestor', 'RH'],
            isActive: (path) => 
                isActive('/relatorios/grupo') || 
                isActive('/relatorios/aluno') || 
                isActive('/relatorios/acompanhamento') ||
                isActive('/relatorios/feedback') ||
                isActive('/relatorios/avaliacao-reacao') ||
                isActive('/relatorios/avaliacao-reacao-hibrido') ||
                isActive('/relatorios/avaliacao-eficacia'),
            onClick: () => setShowModalRelatorios(true)
        },
        {
            path: '/calendario',
            icon: 'bi-calendar-fill',
            label: 'Calendário',
            showFor: ['Aluno'],
            isActive: (path) => isActive('/calendario')
        }
    ];

    return (
        <>
            <div className={`sidebar-content`}>
                <div className="d-flex flex-md-column align-items-center sidenav">
                    <div className="d-flex flex-md-column justify-content-around w-100 sidenav-content">
                        {menuItems.map((item, index) => (
                            item.showFor.includes(nivel) && (
                                <Link
                                    key={index}
                                    to={item.path}
                                    onClick={item.onClick}
                                    className="sidebar-link"
                                    title={item.label}
                                >
                                    <div className={`menu-item-container ${item.isActive(item.path) ? 'menu-item-active' : ''}`}>
                                        <div className="icon-container position-relative">
                                            <i className={`menu-item bi ${item.icon}`}></i>
                                            {item.badge > 0 && (
                                                <span className="notification-badge">
                                                    {item.badge}
                                                </span>
                                            )}
                                        </div>
                                        <span className="menu-label">{item.label}</span>
                                    </div>
                                </Link>
                            )
                        ))}
                    </div>
                </div>
            </div>

            <Modal size="lg" show={showModalRelatorios} onHide={() => setShowModalRelatorios(false)}>
                <Modal.Header closeButton>
                    <Modal.Title className="text-center w-100">
                        <span className="d-block fs-6">Relatórios</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ background: "#f9f9f9" }}>
                    <div className="container mt-2">
                        <div className="text-center mb-4">
                            <h5 className="fs-6 fs-md-5">Selecione um Relatório</h5>
                            <p className="text-muted small">Escolha o tipo de relatório que você deseja visualizar.</p>
                        </div>
                        
                        {/* Versão Desktop */}
                        <div className="d-none d-md-block">
                            <div className="list-group">
                                <Link
                                    to="/relatorios/grupo"
                                    onClick={() => setShowModalRelatorios(false)}
                                    className="list-group-item list-group-item-action d-flex align-items-center p-3"
                                >
                                    <i className="bi bi-people-fill display-4 text-success me-3"></i>
                                    <div>
                                        <h5 className="mb-0">Aulas em Grupo</h5>
                                        <small className="text-muted">Visualize o progresso das aulas em grupo.</small>
                                    </div>
                                </Link>
                                <Link
                                    to="/relatorios/aluno"
                                    onClick={() => setShowModalRelatorios(false)}
                                    className="list-group-item list-group-item-action d-flex align-items-center p-3"
                                >
                                    <i className="bi bi-person-lines-fill display-4 text-primary me-3"></i>
                                    <div>
                                        <h5 className="mb-0">Progresso do Aluno</h5>
                                        <small className="text-muted">Acompanhe o progresso individual dos alunos.</small>
                                    </div>
                                </Link>
                                <Link
                                    to="/relatorios/acompanhamento"
                                    onClick={() => setShowModalRelatorios(false)}
                                    className="list-group-item list-group-item-action d-flex align-items-center p-3"
                                >
                                    <i className="bi bi-credit-card-2-front display-4 text-info me-3"></i>
                                    <div>
                                        <h5 className="mb-0">Acompanhamento de Treinamentos</h5>
                                        <small className="text-muted">Monitore o andamento e desempenho dos treinamentos.</small>
                                    </div>
                                </Link>
                                {(nivel === 'Administrador' || nivel === 'RH') && (
                                    <>
                                        <Link
                                            to="/relatorios/feedback"
                                            onClick={() => setShowModalRelatorios(false)}
                                            className="list-group-item list-group-item-action d-flex align-items-center p-3"
                                        >
                                            <i className="bi bi-graph-up display-4 text-warning me-3"></i>
                                            <div>
                                                <h5 className="mb-0">Estatísticas de Feedback</h5>
                                                <small className="text-muted">Visualize as estatísticas das pesquisas de satisfação.</small>
                                            </div>
                                        </Link>
                                        <Link
                                            to="/relatorios/avaliacao-reacao"
                                            onClick={() => setShowModalRelatorios(false)}
                                            className="list-group-item list-group-item-action d-flex align-items-center p-3"
                                        >
                                            <i className="bi bi-emoji-smile display-4 text-success me-3"></i>
                                            <div>
                                                <h5 className="mb-0">Avaliação de Reação</h5>
                                                <small className="text-muted">Estatísticas das avaliações de reação.</small>
                                            </div>
                                        </Link>
                                        <Link
                                            to="/relatorios/avaliacao-reacao-hibrido"
                                            onClick={() => setShowModalRelatorios(false)}
                                            className="list-group-item list-group-item-action d-flex align-items-center p-3"
                                        >
                                            <i className="bi bi-gem display-4 text-primary me-3"></i>
                                            <div>
                                                <h5 className="mb-0">Avaliação de Reação Híbrido</h5>
                                                <small className="text-muted">Estatísticas das avaliações de reação para treinamentos híbridos.</small>
                                            </div>
                                        </Link>
                                        <Link
                                            to="/relatorios/avaliacao-eficacia"
                                            onClick={() => setShowModalRelatorios(false)}
                                            className="list-group-item list-group-item-action d-flex align-items-center p-3"
                                        >
                                            <i className="bi bi-check2-circle display-4 text-info me-3"></i>
                                            <div>
                                                <h5 className="mb-0">Avaliação de Eficácia</h5>
                                                <small className="text-muted">Estatísticas das avaliações de eficácia.</small>
                                            </div>
                                        </Link>
                                    </>
                                )}
                            </div>
                        </div>

                        {/* Versão Mobile */}
                        <div className="d-md-none">
                            <div className="row">
                                <div className="col-12 mb-2">
                                    <Link
                                        to="/relatorios/grupo"
                                        onClick={() => setShowModalRelatorios(false)}
                                        className="card border-0 shadow-sm rounded-3 text-decoration-none"
                                    >
                                        <div className="card-body p-3">
                                            <div className="d-flex align-items-center">
                                                <i className="bi bi-people-fill fs-2 text-success me-3"></i>
                                                <div className="flex-grow-1">
                                                    <h6 className="mb-1 fw-semibold text-dark">Aulas em Grupo</h6>
                                                    <small className="text-muted">Visualize o progresso das aulas em grupo.</small>
                                                </div>
                                                <i className="bi bi-chevron-right text-muted"></i>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-12 mb-2">
                                    <Link
                                        to="/relatorios/aluno"
                                        onClick={() => setShowModalRelatorios(false)}
                                        className="card border-0 shadow-sm rounded-3 text-decoration-none"
                                    >
                                        <div className="card-body p-3">
                                            <div className="d-flex align-items-center">
                                                <i className="bi bi-person-lines-fill fs-2 text-primary me-3"></i>
                                                <div className="flex-grow-1">
                                                    <h6 className="mb-1 fw-semibold text-dark">Progresso do Aluno</h6>
                                                    <small className="text-muted">Acompanhe o progresso individual dos alunos.</small>
                                                </div>
                                                <i className="bi bi-chevron-right text-muted"></i>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-12 mb-2">
                                    <Link
                                        to="/relatorios/acompanhamento"
                                        onClick={() => setShowModalRelatorios(false)}
                                        className="card border-0 shadow-sm rounded-3 text-decoration-none"
                                    >
                                        <div className="card-body p-3">
                                            <div className="d-flex align-items-center">
                                                <i className="bi bi-credit-card-2-front fs-2 text-info me-3"></i>
                                                <div className="flex-grow-1">
                                                    <h6 className="mb-1 fw-semibold text-dark">Acompanhamento de Treinamentos</h6>
                                                    <small className="text-muted">Monitore o andamento e desempenho dos treinamentos.</small>
                                                </div>
                                                <i className="bi bi-chevron-right text-muted"></i>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                {(nivel === 'Administrador' || nivel === 'RH') && (
                                    <>
                                        <div className="col-12 mb-2">
                                            <Link
                                                to="/relatorios/feedback"
                                                onClick={() => setShowModalRelatorios(false)}
                                                className="card border-0 shadow-sm rounded-3 text-decoration-none"
                                            >
                                                <div className="card-body p-3">
                                                    <div className="d-flex align-items-center">
                                                        <i className="bi bi-graph-up fs-2 text-warning me-3"></i>
                                                        <div className="flex-grow-1">
                                                            <h6 className="mb-1 fw-semibold text-dark">Estatísticas de Feedback</h6>
                                                            <small className="text-muted">Visualize as estatísticas das pesquisas de satisfação.</small>
                                                        </div>
                                                        <i className="bi bi-chevron-right text-muted"></i>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                        <div className="col-12 mb-2">
                                            <Link
                                                to="/relatorios/avaliacao-reacao"
                                                onClick={() => setShowModalRelatorios(false)}
                                                className="card border-0 shadow-sm rounded-3 text-decoration-none"
                                            >
                                                <div className="card-body p-3">
                                                    <div className="d-flex align-items-center">
                                                        <i className="bi bi-emoji-smile fs-2 text-success me-3"></i>
                                                        <div className="flex-grow-1">
                                                            <h6 className="mb-1 fw-semibold text-dark">Avaliação de Reação</h6>
                                                            <small className="text-muted">Estatísticas das avaliações de reação.</small>
                                                        </div>
                                                        <i className="bi bi-chevron-right text-muted"></i>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                        <div className="col-12 mb-2">
                                            <Link
                                                to="/relatorios/avaliacao-reacao-hibrido"
                                                onClick={() => setShowModalRelatorios(false)}
                                                className="card border-0 shadow-sm rounded-3 text-decoration-none"
                                            >
                                                <div className="card-body p-3">
                                                    <div className="d-flex align-items-center">
                                                        <i className="bi bi-gem fs-2 text-primary me-3"></i>
                                                        <div className="flex-grow-1">
                                                            <h6 className="mb-1 fw-semibold text-dark">Avaliação de Reação Híbrido</h6>
                                                            <small className="text-muted">Estatísticas das avaliações de reação para treinamentos híbridos.</small>
                                                        </div>
                                                        <i className="bi bi-chevron-right text-muted"></i>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                        <div className="col-12 mb-2">
                                            <Link
                                                to="/relatorios/avaliacao-eficacia"
                                                onClick={() => setShowModalRelatorios(false)}
                                                className="card border-0 shadow-sm rounded-3 text-decoration-none"
                                            >
                                                <div className="card-body p-3">
                                                    <div className="d-flex align-items-center">
                                                        <i className="bi bi-check2-circle fs-2 text-info me-3"></i>
                                                        <div className="flex-grow-1">
                                                            <h6 className="mb-1 fw-semibold text-dark">Avaliação de Eficácia</h6>
                                                            <small className="text-muted">Estatísticas das avaliações de eficácia.</small>
                                                        </div>
                                                        <i className="bi bi-chevron-right text-muted"></i>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <button className="btn btn-outline-primary" onClick={() => setShowModalRelatorios(false)}>
                        Fechar
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Sidebar;